var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F2F3F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43427 7.43433C7.74669 7.12191 8.25322 7.12191 8.56564 7.43433L12 10.8686L15.4343 7.43433C15.7467 7.12191 16.2532 7.12191 16.5656 7.43433C16.8781 7.74675 16.8781 8.25328 16.5656 8.5657L13.1313 12L16.5656 15.4343C16.8781 15.7467 16.8781 16.2533 16.5656 16.5657C16.2532 16.8781 15.7467 16.8781 15.4343 16.5657L12 13.1314L8.56564 16.5657C8.25322 16.8781 7.74669 16.8781 7.43427 16.5657C7.12185 16.2533 7.12185 15.7467 7.43427 15.4343L10.8686 12L7.43427 8.5657C7.12185 8.25328 7.12185 7.74675 7.43427 7.43433Z",
    fill: "#07070C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.0ec5b321bd9d8f06c8d2ad8be07a0a11.svg";
export { ForwardRef as ReactComponent };